// Expand Shopify JS API
Shopify = Shopify || {};

window.Lemonade = window.Lemonade || {};

var bodyClasses = document.body.classList;

var isMobile = {
  Android: function() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};

if(isMobile.any()){
  document.body.classList.add('is-mobile');
}

// API for utility functions
var Utilities = (function() {
  
  return {
  
    handleize: function(str) {
      return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    },

    getQueryParam: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    openModal: function(el){
      $.fancybox.open([{
        maxWidth: 600,
        width: 600,
        height: 600,
        autoSize: true,
        href: el
      }], {
        padding: 50
      });    
    },

    openCartFlyout: function(){
      Lemonade.cache.$cartFlyout.show();
      setTimeout(function(){
        Utilities.resizeCartFlyout();
        Lemonade.cache.$cartFlyout.addClass('Show');
      }, 100);      
    },

    closeCartFlyout: function(){
      Lemonade.cache.$cartFlyout.removeClass('Show');
      setTimeout(function(){
        Lemonade.cache.$cartFlyout.hide();
      }, 300);
    },

    addProductToCart: function(data, successCallback, errorCallback){
      $.ajax({ url: '/cart/add.js', type: 'post', dataType: 'json',
        data: data,
        success: function(data, textStatus, jqXHR) {
          if (textStatus === 'success') {
            Utilities.updateCart(successCallback, true);
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          errorCallback 
            ? errorCallback(jqXHR.responseJSON.description)
            : alert(jqXHR.responseJSON.description);
        }
      });
    },

    addProductsToCart: function(productQueue){
      if (productQueue.length) {
        var data = productQueue.shift();
        $.ajax({ url: '/cart/add.js', type: 'post', dataType: 'json',
          data: data,
          success: function(data, textStatus, jqXHR) {
            Utilities.addProductsToCart(productQueue);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            errorCallback && errorCallback(jqXHR.responseJSON.description);
          }
        });
      } else {
        document.location.href = '/cart';
      }
    },

    updateCartQuantity: function(data, successCallback, errorCallback){
      $.ajax({
        url: '/cart/change.js',
        type: 'post',
        dataType: 'json',
        data: data,
        success: function(cart) {
          Utilities.updateCart(cart, true);
        },
        error: function(XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      }); 
    },

    updateCart: function(callback, openFlyout){
      $.getJSON('/cart.js', function(cart){
        Utilities.renderCartFlyout(cart, openFlyout);
        //callback && callback(cart);
      });
    },

    changeCart: function(cartItemsQueue){
      if (cartItemsQueue.length) {
        var data = cartItemsQueue.shift();
        $.ajax('cart/change.js', {
          data: data,
          dataType: 'json',
          success: function(cart){
            Utilities.changeCart(cartItemsQueue);
          }
        })
      } else {
        window.location.reload();
      }
    }, 

    renderCartFlyout: function(cart, openFlyout){      
      var icon_count;
      if(cart.item_count === 0){
        Lemonade.cache.$cartFlyout.addClass('empty');
        item_count = "";
      } else {
        Lemonade.cache.$cartFlyout.removeClass('empty');
        item_count = cart.item_count;
      } 

      $('.CartCount').text(item_count);

      // show cart flyout
      var source = $("#cart-template").html(),
          template = Handlebars.compile(source),
          items = [],
          classes,
          option_label,
          imgSmall;

      $.each(cart.items, function(i,variant){
        imgSmall = variant.image ? variant.image.replace(/^(.+)(\..+)$/, '$1_medium$2') : '';
        classes = variant.discounted_price ? '' : 'free-item';
        option_label = (variant.handle == 'gift-card') ? 'Amount' : 'Color';
        price_qty = variant.discounted_price * variant.quantity;

        items.push({
          id: variant.id,
          vendor: variant.vendor,
          title: variant.product_title,
          variant_title: variant.variant_title,
          url: variant.url,
          qty: variant.quantity,
          price: Shopify.formatMoney(variant.discounted_price),
          price_total: Shopify.formatMoney(price_qty),
          image: imgSmall,
          option1: variant.variant_options[0],
          option2: variant.variant_options[1],
          option3: variant.variant_options[2],
          optionLabel: option_label,
          classes: classes
        });
      });

      $('#Subtotal span').html( Shopify.formatMoney( cart.total_price ));
      Lemonade.cache.$cartFlyoutProducts.html( template({items:items}) );
      openFlyout && Utilities.openCartFlyout();
    },

    resizeCartFlyout: function(){
      Lemonade.cache.$cartFlyoutProducts.css({
        maxHeight: (Lemonade.cache.$win.outerHeight() - ($('#flyout-header').outerHeight() + Lemonade.cache.$header.outerHeight() + $('#CartFlyoutSummary').outerHeight()))
      });
    }

  }

})();

// Global selectors and values
Lemonade.cacheSelectors = function(){

	Lemonade.cache = {
		
		// General
		$win: $(window),
    $body: $('html,body'),
    $mainContent: $('.main-content'),
		
		// Header & Nav
    header: document.getElementById('AppHeader'),
    $header: $('#AppHeader'),
		$appBanner: $('#AppBanner'),
    headerSpecs: null,
		
		// Cart
		$cartCount: $('.CartCount'),
    $cartFlyout: $('#CartFlyout'),
    $cartFlyoutProducts: $('#CartFlyoutProducts'),
    $cartFlyoutSubtotal: $('#CartFlyoutSubtotal')  
    		
	};
	
};

// Kick off functions
Lemonade.init = function(){
  Lemonade.cacheSelectors();
  Lemonade.windowState();
  Lemonade.lazyLoad();
  Lemonade.inView();
  Lemonade.appHeader();
  Lemonade.slick();
  Lemonade.benefitsModule();
	Lemonade.autoResponsiveElements();
	Lemonade.cache.$win.load(function(){
		Lemonade.fitVids();
	});
	
	Lemonade.sticky();
	Lemonade.mailchimp();
	Lemonade.customProductSelects();
	Lemonade.customSelects();
	Lemonade.productQuantity();
	Lemonade.initCartFlyout();
	Lemonade.cartNote();
  Lemonade.labels();
  Lemonade.customizeModule();
  //Lemonade.partialSearch();
  
  if(bodyClasses.contains('template-collection')){
    Lemonade.loadMore();
    Lemonade.collectionPage();
    Lemonade.gridToggle();
    Lemonade.accordionPLP();
  } else {
    Lemonade.accordion();
  }

  if(bodyClasses.contains('template-search')){
    Lemonade.loadMore();
    Lemonade.gridToggle();
  }

  if(bodyClasses.contains('template-product')){
    Lemonade.productMedia();
    Lemonade.productCustomizer();
    Lemonade.productZoom();
  }  

  if(bodyClasses.contains('template-blog')){
    Lemonade.loadMore();
    Lemonade.blogPage();
  }

  if(bodyClasses.contains('template-article')){
    Lemonade.blogPage();
  }
};

Lemonade.windowState = function(){
  var win_width,
      state;

  // Check state of window width (wide vs narrow screen)
	var winState = function() {
		win_width = Lemonade.cache.$win.width();
		if(win_width > 1023){
			if (state != 'max') {
				state = 'max';
				changedstate(state);
			};
		} else if (win_width > 767 && win_width <= 1023){
			if (state != 'desktop') {
				state = 'desktop';
				changedstate(state);
			};
		} else {
			if (state != 'mobile') {
				state = 'mobile';
				changedstate(state);
			};
		}
	};

  // If/When window crosses the wide/narrow threshold you can do some stuff here
	function changedstate(mystate){
		if(mystate == 'max'){
			Lemonade.cache.$body
				.removeClass('NarrowScreen WideScreen')
				.addClass('MaxScreen');
		} else if(mystate == 'desktop'){
			// Do wide screen stuff here
			Lemonade.cache.$body
			  .removeClass('NarrowScreen MaxScreen')
        .addClass('WideScreen');
	  } else {
		  // Do narrow screen stuff here
		  Lemonade.cache.$body
		    .removeClass('WideScreen MaxScreen')
        .addClass('NarrowScreen');
      Lemonade.resetBadges();
      if($('#popup-bg')){
        $('#popup-bg').click();
      }
	  }
  }

  winState();

	Lemonade.cache.$win.on({
		resize: function(){
			winState();
		}
	});


}

// Lazy Load library dependancy http://jquery.eisbehr.de/lazy
// Dynamically load images
Lemonade.lazyLoad = function(){
	$('.Lazy').Lazy({
		effect: 'fadeIn',
		visibilityOnly: true,
		onError: function(element){
			console.log('error loading ' + element.data('src'));
		},
		afterLoad: function(element) {
      if(bodyClasses.contains('template-product')){
        //Lemonade.productZoom();
      }
		}
	});
};

// Return window scrollTop
Lemonade.windowScrollTop = function(){
	return $(window).scrollTop();
};

// Body no scroll
Lemonade.scrollYes = function(){
	Lemonade.cache.$body.removeClass('NoScroll');
};

// Body yes scroll
Lemonade.scrollNo = function(){
	Lemonade.cache.$body.addClass('NoScroll');
};

// Return a bunch of header specs
Lemonade.headerCalculations = function(){
	var total_offset = Lemonade.cache.$header.height() + Lemonade.cache.$appBanner.outerHeight();
  
  Lemonade.cache.headerSpecs = {
	  header_height: Lemonade.cache.$header.height(),
	  bar_height: Lemonade.cache.$appBanner.outerHeight(),
	  header_plus_bar: Lemonade.cache.$header.height() + Lemonade.cache.$appBanner.outerHeight(),
	  total_offset: total_offset
  };
  
  return Lemonade.cache.headerSpecs;
	
};

// Animate elements when in view
Lemonade.inView = function(){
	$('.AnimateIn').one('inview', function(event, isInView) {
	  if (isInView) {
	    $(this).addClass('InView');
	  }
	});
};

Lemonade.appHeader = function(){

  var navLink = document.querySelectorAll('.NavLink'),
      dropdown = document.querySelectorAll('.MenuDropdown'),
      Hamburger = document.getElementById('Hamburger'),
      MobileMenu = document.getElementById('AppNavMobile'),
      MobileSubMenuTrigger = document.querySelectorAll('.MobilePanelTrigger'),
      panels = document.querySelectorAll('.MobileMenuPanel'),
      ReturnPanel = document.querySelectorAll('.ReturnPanel'),
      searchTrigger = document.getElementById('SearchTrigger'),
      searchForm = document.getElementById('AppSearch'),
      meMenu = null,
      dropdownTimer = null,
      headerHeight = null,
      lastScrollTop = 0;

  function closeDropdown(){
    Lemonade.cache.header.classList.remove('Open');
    navLink.forEach(function(element){
      element.setAttribute('aria-expanded', 'false');
      element.classList.remove('Active');
    });
    dropdown.forEach(function(element){
      element.style.display = 'none';
      // element.setAttribute('aria-hidden', 'true');
    });
  }

  function openDropdown(el){
    clearTimeout(dropdownTimer);
    var meDataMenu = el.getAttribute('data-dropdown'),
        meMenu = document.getElementById(meDataMenu);
    el.setAttribute('aria-expanded', 'true');
    closeDropdown();
    Lemonade.cache.header.classList.add('Open');
    el.classList.add('Active');
    meMenu.style.display = 'block';    
  }

  function closeAppSearch(){
    searchTrigger.classList.remove('Active');
    searchTrigger.setAttribute('aria-expended', 'false');
    searchForm.classList.remove('Show');
    searchForm.setAttribute('aria-hidden', 'true');
  }

  function openAppSearch(){    
    searchTrigger.classList.add('Active');
    searchTrigger.setAttribute('aria-expanded', 'true');
    searchForm.classList.add('Show');
    searchForm.setAttribute('aria-hidden', 'false');
  }

  function openMobileMenu(){
    if(Hamburger.classList.contains('Open')){
      closeMobileMenu();
    } else {
      Hamburger.classList.add('Open');
      MobileMenu.classList.add('ShowMenu');
      Lemonade.scrollNo();
    }
  }

  function closeMobileMenu(){
    MobileMenu.classList.remove('ShowMenu');
    Hamburger.classList.remove('Open');
    Lemonade.scrollYes();
    setTimeout(function(){
      closePanels();
    }, 500);
  }

  function closePanels(){
    panels.forEach(function(element){
      element.classList.remove('ShowMenu');
    });
  }

  function headerAnimate(){
    headerHeight = Lemonade.cache.$header.height();
    currentScroll = Lemonade.windowScrollTop();
    
    if(currentScroll < 1){
      Lemonade.cache.$header.removeClass('Attach fix');
      Lemonade.cache.$mainContent.removeClass('fix');
    } else if (currentScroll < lastScrollTop){
      if(currentScroll > headerHeight){
        Lemonade.cache.$header.addClass('fix animate Attach');
        Lemonade.cache.$mainContent.addClass('fix');     
      } else {
        Lemonade.cache.$header.removeClass('animate');
      }         
    } else {
      if(currentScroll > headerHeight){ 
        Lemonade.cache.$header.addClass('animate').removeClass('Attach');
      }
    }
    lastScrollTop = currentScroll;
  }

  navLink.forEach(function(element){
    element.addEventListener('click', function(e){
      var me = this;
      if(me.classList.contains('Active')){
        closeDropdown();  
      } else if(me.classList.contains('HasDropdown')) {
        openDropdown(me);
      }
    });

    element.addEventListener('mouseenter', function(e){
      var me = this;
      if(me.classList.contains('HasDropdown')) {
        openDropdown(me);
      }
    });

    element.addEventListener('mouseleave', function(e){
      dropdownTimer = setTimeout(function(){
        closeDropdown();
        element.classList.remove('stay-open');
      }, 400);
    });    

  });
 
  dropdown.forEach(function(element){
    element.addEventListener('mouseenter', function(e){
      clearTimeout(dropdownTimer);
      element.classList.add('stay-open');
    });  
  
    element.addEventListener('mouseleave', function(e){
      closeDropdown();
      element.classList.remove('stay-open');
    });
  });

  MobileSubMenuTrigger.forEach(function(element){
    element.addEventListener('click', function(e){
      e.preventDefault();
      meTrigger = this;
      meSubData = this.getAttribute('data-submenu');
      mePanel = document.getElementById(meSubData);
      closePanels();
      mePanel.classList.add('ShowMenu');
    });
  });

  ReturnPanel.forEach(function(element){
    element.addEventListener('click', function(e){
      closePanels();
    });
  });

  Hamburger.addEventListener('click', openMobileMenu);
  searchTrigger.addEventListener('click', openAppSearch);

  $('.main-content').click(function(e){
    if(!$(e.target).hasClass('search-element')){
      closeAppSearch();
    }
  });

  Lemonade.cache.$win.scroll(function(){
    headerAnimate();
  });  

};

// Content accordions
Lemonade.accordion = function(){

  var $accTrigger = $('.AccTrigger'),
      $acc = $('.AccContent');
  
  // accordian content    
  $accTrigger.click(function(e){
    e.preventDefault();
    
    var $me = $(this),
        $content = $me.next('.AccContent');
        
    $acc.slideUp(function(){
      $(document.body).trigger("sticky_kit:recalc");
    }).attr('aria-hidden', 'true');
    if($me.hasClass('Open')){
      $me.removeClass('Open').attr('aria-expanded', 'false');
      return false;
    }
    $accTrigger.removeClass('Open').attr('aria-expanded', 'false');
    $me.addClass('Open').attr('aria-expanded', 'true');
    $content.slideDown(function(){
      $(document.body).trigger("sticky_kit:recalc");
    }).attr('aria-hidden', 'false');
  });	
	
};

Lemonade.accordionPLP = function(){
	
  var $accTrigger = $('.AccTrigger'),
      $acc = $('.AccContent');
  
  // accordian content    
  $accTrigger.click(function(e){
    e.preventDefault();
    
    var $me = $(this),
        $content = $me.next('.AccContent');

    if($me.hasClass('Open')){
      $me.removeClass('Open').attr('aria-expanded', 'false');
      $content.slideUp(function(){
        $(document.body).trigger("sticky_kit:recalc");
      }).attr('aria-hidden', 'true');
    } else {
      $me.addClass('Open').attr('aria-expanded', 'true');
      $content.slideDown(function(){
        $(document.body).trigger("sticky_kit:recalc");
      }).attr('aria-hidden', 'false');      
    }
  });	
	
};

// Slick init
Lemonade.slick = function(){
	
	var $slick = $('.Slick'),
	    $mobileSlick = $('.MobileSlick');
  
      
  $slick.on('init', function(){
    Lemonade.slickAlignArrows();
  });

	$slick.slick({
		lazyLoad: 'progressive'
	});

	Lemonade.cache.$win.on({
		load: function(){
			if(Lemonade.cache.$body.hasClass('NarrowScreen')){
				$mobileSlick.slick({
					lazyLoad: 'progressive'
				});
			}
		},
		resize: function(){
			if(Lemonade.cache.$body.hasClass('MaxScreen') || Lemonade.cache.$body.hasClass('WideScreen')){
				if($mobileSlick.hasClass('slick-initialized')){
					$mobileSlick.slick('unslick');
				}
			} else {
				if(!$mobileSlick.hasClass('slick-initialized')){
					$mobileSlick.slick({
						lazyLoad: 'progressive'
					});
				}
      }
      Lemonade.slickAlignArrows();
		}
	});

};

// Slick carousel vertically align prev/next arrows to carousel item image
Lemonade.slickAlignArrows = function(){
	
	setTimeout(function(){
		
		$('.Slideshow').each(function(i, el){
			var $me = $(el);
			if($me.hasClass('carousel') && $me.hasClass('no-autoalign') == false){
				var imgHeight = $me.find('.slick-slide').first().find('img').first().height() / 2;
			  $me.find('.slick-arrow').css({'top': imgHeight - 15});
			} else {
				$('.SlideArrow').addClass('init');
			}
			
		});
	}, 600);
	
};


Lemonade.benefitsModule = function(){

  var BT = document.querySelectorAll('.BenefitTrigger');

  function resetBenefits(){
    BT.forEach(function(element){
      var me = element,
          me_benefit = me.getAttribute('data-benefit'); 
      me.classList.remove('Active');
      me.setAttribute('aria-expanded', 'false');
      document.getElementById(me_benefit).classList.remove('Show');
      document.getElementById(me_benefit).setAttribute('aria-hidden', 'true');
    });
  }

  function showBenefit(element){
    var me = element,
        me_benefit = me.getAttribute('data-benefit');

    if(!me.classList.contains('Active')){
      resetBenefits();
      me.classList.add('Active');
      me.setAttribute('aria-expanded', 'true');
      document.getElementById(me_benefit).classList.add('Show');
      document.getElementById(me_benefit).setAttribute('aria-hidden', 'false');
    }
  }

  BT.forEach(function(element){
    var me = element;
    me.addEventListener('mouseenter', function(){
      showBenefit(me);
    });
  });

};

Lemonade.autoResponsiveElements = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'),
      $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

// Video embed sizing http://fitvidsjs.com/
Lemonade.fitVids = function(){
	Lemonade.cache.$body.find('.video-wrapper').fitVids();
};

// PDP Media controls
Lemonade.productMedia = function() {

  var $play_btn = $('.PlayBtn'),
      $pSlick = $('#ProductSlick'),
      $thumb = $('.ProductThumb'),
      $badgeOverlay = $( "#badge-overlay" );

  function pauseVid(){
    pdp_vid.pause();
    $play_btn
      .find('.Pause')
      .hide()
      .end()
      .find('.Play')
      .show();    
  }

  function playVid(){
    pdp_vid.play();
    $play_btn
      .find('.Play')
      .hide()
      .end()
      .find('.Pause')
      .show();    
  }

	$('.ProductVideo').click(function(){
    var $me = $(this).find('.PlayBtn');
    var active_id = $(this).find("video").attr("id")
    var pdp_vid = document.getElementById(active_id)
    if(pdp_vid.paused){
 pdp_vid.play();
    } else {
    pdp_vid.pause();
    }
  }); 
  
  $thumb.click(function(){
    var $me = $(this),
        me_index = $me.index();

    $('#ProductSlick').slick('slickGoTo', me_index);

		if(!$me.hasClass('Active')){     
      $me.addClass('Active').siblings('.ProductThumb').removeClass('Active');
 $('video').each(function(index){
    $(this).get(0).pause();
});
		}
  });

  $pSlick.on('afterChange', function(event, slick, currentSlide){
    $thumb.eq(currentSlide).addClass('Active').siblings('.ProductThumb').removeClass('Active');
     $('video').each(function(index){
    $(this).get(0).pause();
});
  });

  $pSlick.find('*[draggable!=true]','.slick-track').unbind('dragstart');
  $badgeOverlay.draggable({ containment: "#badge-preview", scroll: false });

  $badgeOverlay.on("draggable mouseenter mousedown",function(event){
    event.stopPropagation();
  });

  $badgeOverlay.on('dragstart', function(){
    $('#badge-overlay').find('.title-xs').hide();
  });

};

// PDP sticky sidebar
Lemonade.sticky = function(){   
		
	Lemonade.cache.$win.on({
		load: function(){
			if(!Lemonade.cache.$body.hasClass('NarrowScreen')){
				stickyKit();
			}
		},
		resize: function(){
			if(Lemonade.cache.$body.hasClass('MaxScreen') || Lemonade.cache.$body.hasClass('WideScreen')){
				stickyKit();
			} else {
				detachStickyKit();
			}
		}

	});

	function detachStickyKit(){
		$("#collection-sidebar, #product-images").trigger("sticky_kit:detach");
	}

	function stickyKit(){  
    var offset_amt = Lemonade.cache.$header.height();
		$("#collection-sidebar, #product-images").stick_in_parent({
      offset_top: offset_amt,
			parent: '.sticky-parent'
    });  
	}
}

// Mailchimp Ajax submit
Lemonade.mailchimp = function(){
	
	var statusMessage;
		
	function mailchimpSubmit(formSubmit){
		
		var $meSubmit = $(formSubmit),
		    $meForm = $meSubmit.closest('form');
		
		$.ajax({
	    type: $meForm.attr('method'),
	    url: $meForm.attr('action'),
	    data: $meForm.serialize(),
	    cache       : false,
	    dataType    : 'json',
	    contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if(data.result != "success") {
          if(liquidVars.signupFail){
		        statusMessage = liquidVars.signupFail;
          } else {
		        statusMessage = 'Sorry try again later.';
          }
        } else {
	        if(liquidVars.signupSuccess){
            statusMessage = liquidVars.signupSuccess;
          } else {
		        statusMessage = 'Thanks';
          }
        }
				$meForm.next('.SubscribeStatus').html(statusMessage).fadeIn(function(){
					setTimeout(function(){
						$meForm.next('.SubscribeStatus').fadeOut(function(){
							$(this).html('');
							$meForm.find('input[type="email"]').val('');
						});							
					}, 3000);
				});
      }
	  });
	}
	
	$('.NewsletterContainer').on('click', 'input[type="submit"]', function(e){
		e.preventDefault();
		mailchimpSubmit($(this));
	});
	
	
};

// Product Zoom
Lemonade.productZoom = function(){


	$(".ProductImage .Zoom").on('click', function(){
		if(!isMobile.any()){
			$me = $(this);
	    if($('.enabled').length === 0){
	      $me.elevateZoom({
		      zoomType: "inner",
		      cursor: "crosshair",
		      zoomWindowFadeIn: 300,
		      zoomWindowFadeOut: 300
	      });			
	      $(this).toggleClass('enabled');
	    } else {
	      $(this).toggleClass('enabled');
	      $('.zoomContainer').hide().remove();
	    }
    }
   });



  // $(".ProductImage .Zoom").elevateZoom({
  //   zoomType: "inner",
  //   cursor: "crosshair"
  // });
}; 

// Product custom selects
Lemonade.customProductSelects = function(){

	var $selectorWrap = $('.selector-wrapper');
	
	// Loop through all variant options and construct custom UI
	$selectorWrap.each(function(i,el){
		var $me = $(el),
				$meSelect = $me.find('.single-option-selector'),
				$meLabel = $me.find('label'),
				meLabelText = $meLabel.text(),
        $meOptions = $me.find('option'),
				$meUl = $('<div class="material-row"><span class="label"></span><div class="OptionSelect"></div></div>'),
        $newLabel = $('<div class="selection label">'+meLabelText+': <span class="color-label"><span></div>'),
        optionField = $meSelect.data('option');

		// build options in option select dropdown with data-attributes derived from real select
		$meOptions.each(function(i, el){
			var $el = $(el),
					meText = $el.text(),
					meVal = $el.val().replace(/["]/g, "&quot;"),
          meHandle = Utilities.handleize(meText),
          isSelected = Boolean(Lemonade.selectedVariant && Lemonade.selectedVariant[optionField] === meText);

			$meUl.find('.OptionSelect').append('<div class="' + meHandle + (isSelected ? ' Active' : '') +'" data-val="' + meVal + '">' + meText + '</div>');
    });	    
    
		// Hide default select field + label
    $meLabel.add($meSelect).hide();

    // Add new selections to DOM
    if ($meUl.find('div').length > 0) {
      $me.prepend($meUl);
    }

		// Add new selections to DOM
		if(meLabelText == 'Color'){
			$me.addClass('color').prepend($newLabel);
		} else {
			$me
				.prepend('<div class="OptionBox"><span class="OptionTitle">Select '+$meLabel.text()+'</span><span class="icon icon-arrow"><svg><use xlink:href="#icon-down"></use></svg></span></div>')
				.prepend($newLabel);			
		}

	});
	
};

Lemonade.customSelects = function(){
  var $selectorWrap = $('.selector-wrapper, .fake-select'),
      $addForm = $('#AddToCartForm');
	
  $addForm.on('click', '.selector-wrapper div', function(e){
		e.stopPropagation();
		var $me = $(this),
        meVal = $me.data('val'),
        meValStripped = $me.text().replace(" USD", "");
        
    $('.color-label').text(meValStripped);

    $addForm.find('.selector-wrapper div').removeClass('Active');
  
		if(!$me.hasClass('Active')){			
			$me
				.addClass('Active')
				.siblings('div')
				.removeClass('Active')
				.end()
				.closest('.selector-wrapper')
				.find('.single-option-selector')
				.val(meVal)
				.change();
		}
		
  });	

 
	$selectorWrap.on('click', '.OptionBox', function(e){
		e.stopPropagation();
    var $me = $(this);
		if($me.hasClass('Active')){
			$me
				.removeClass('Active')
				.next('.OptionSelect')
				.hide();
		} else {
			$selectorWrap.find('.OptionBox').removeClass('Active').next('.OptionSelect').hide();
      $me
        .removeClass('tilt')
				.addClass('Active')
				.next('.OptionSelect')
				.show();
		}
	});
};

// Custom product quantity
Lemonade.productQuantity = function(){

  $(".Qty span").on("click", function() {
    var $button = $(this),
        $qtyField = $button.siblings('.cart__quantity-selector'),
        dataID = $qtyField.attr('data-qty-id'),
        oldVal = $qtyField.val(),
        newVal;
    
    newVal = $button.hasClass('up')
      ? parseFloat(oldVal) + 1
      : oldVal > 0
        ? parseFloat(oldVal) - 1 
        : 0
        ;
      ;

	  $('[data-qty-id='+dataID+']').attr('value', newVal);
	});
	
};

// Product Page
Lemonade.changeVariant = function(options){
  var moneyFormat = options.money_format,
      variant = options.variant,
      translations = options.translations;

  // Selectors
  var $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
			$quantityElements = $('.ProductQty'),
			$addToCartForm = $('#AddToCartForm'),
			$addToCartText = $('#AddToCartText'),
      $customizeBtn = $('#customizeBtn');
			
	function restockCheck(){
		if($addToCartForm.hasClass('restock')){
      btn_msg = translations.sold_out + ' - ' + translations.back_in_stock + ' ' + translations.restock_date;
      $addToCartText.html(btn_msg).addClass('small-text');  
		} else {
      $addToCartText.html(translations.sold_out);
     var variant_restock_date = ".restock_date-" + variant.id 
          $('#back-in-stock').show(); 
                    $('#back-in-stock a').show(); 

          $(variant_restock_date).show(); 
          console.log('conditional hit')
    }
    
  }
  
  if (variant) {
    // Select a valid variant if available
    if (variant.available) {
			// Available, enable the submit button, change text, show quantity elements
			$addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(translations.add_to_cart);
      $quantityElements.show();
      $customizeBtn.show();
      $('#back-in-stock').hide();
     $('.restock_date').hide()

    } else {
      // Sold out, check for restock, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $quantityElements.hide();
      $('#back-in-stock').show();
                $('.restock_date').hide()

			restockCheck();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
		$quantityElements.hide();
		restockCheck();
  }

  $('.pa-item img').click(function(){
    var me_img = $(this).clone();
    $('#popup-img').html(me_img);
    $('#popup-bg').show();
    Lemonade.scrollNo();
  });

  $('#popup-bg').click(function(){
    $('#popup-bg').hide();
    Lemonade.scrollYes();
  });
  
};

Lemonade.productCustomizer = function(){

  var source = $("#product-custom-options").html(),
      template = Handlebars.compile(source),
      panelTrigger = document.querySelectorAll('.PanelTrigger'),
      $cGroup = $('#customize-group'),
      $badgePreviewBtn = $('#BadgePreviewBtn'),
      badgeOnly = document.querySelectorAll('.BadgeOnly'),
      badgeOverlay = document.getElementById('badge-overlay'),
      badgeOverlayImg = document.getElementById('badge-overlay-img'),
      $customizeBtn = $('.CustomizeBtn'),
      $addAdditional = $('#AddAdditional'),
      $cHeader = $('.customize-header'),
      hasBadge = false,
      badgeId;
      
  function panelVisible(trigger){
    var me = trigger,
        me_data_panel = me.getAttribute('data-panel'),
        me_panel = document.getElementById(me_data_panel);

    if(me.classList.contains('Active')){
      me.classList.remove('Active');
      me_panel.classList.remove('Show');
      resetCustomizer();
    } else {
      me.classList.add('Active');
      me_panel.classList.add('Show');
    }
  }

  function resetCustomizer(){
    badgeOverlay.style.display = 'none';
    badgeOverlayImg.setAttribute('src', '');
    $('.BadgeItem').removeClass('Selected');
    $customizeBtn.addClass('disabled');
    $addAdditional.html(liquidVars.selectBadge);
  }

  function closePanel(){
    $('#OptionsBtn').removeClass('Active');
    $('#shopify-section-product-customization').removeClass('Show');
  }

  function changeOptionGroup(handle){
    $.ajax({
      url: '/collections/'+handle+'?view=json',
      dataType: 'html',
      async: true,
      success: function(data){
        var prod = JSON.parse(data),
            items = [];
        $.each(prod.products, function(i,el){
          items.push({
            available: el.available,
            title: el.title,
            id: el.id,
            img: el.image,
            alt: el.alt,
            price: el.price,
            type: el.type
          });
        });
        if(handle == 'straps'){
          $cGroup.addClass('four-per');
          $addAdditional.html(liquidVars.selectStrap);
          customizeHeader('straps');
          badgeOnly.forEach(function(element){
            element.style.display = 'none';
          });
        } else {
          $cGroup.removeClass('four-per');
          $addAdditional.html(liquidVars.selectBadge);
          customizeHeader('badges');
          badgeOnly.forEach(function(element){
            element.style.display = 'inline-block';
          });          
        }
        $cGroup.html( template({items:items}) ).removeClass('Loading');
      }
    });
  }

  function badgePreview(){
    var ind = $('#badge-preview').index() - 1;
    Lemonade.cache.$body.animate({'scrollTop': 0});
    $('#ProductSlick').slick('slickGoTo', ind);
  }

  function customizeHeader(type){
    if(type == 'straps'){
      $cHeader
      .find('.desktop-only')
      .html(liquidVars.messageStrap)
      .end()
      .find('.mobile-only')
      .html(liquidVars.messageStrapShort);      
    } else {
      $cHeader
        .find('.desktop-only')
        .html(liquidVars.message)
        .end()
        .find('.mobile-only')
        .html(liquidVars.messageShort);
    }
  }

  panelTrigger.forEach(function(element){
    element.addEventListener('click', function(e){
      var me = element;
      e.stopPropagation();
      if(me.getAttribute('id') == 'customizeBtn'){
        if(!me.classList.contains('Active')){
          $('.OptionGroup').first().click();
        }
        setTimeout(function(){
          panelVisible(me);
        }, 350);
      } else {
        panelVisible(me);
      }
      
    });
  });

  $('.OptionGroup').click(function(){
    var $me = $(this),
        me_data = $me.attr('data-option-group'),
        me_title = $me.text();

    if(!$me.hasClass('Active')){
      $me.addClass('Active').siblings('.OptionGroup').removeClass('Active');
      $('#CurrentLabel').text(me_title);
      $cGroup.addClass('Loading');
      closePanel();
      changeOptionGroup(me_data);
    }
  });

  $cGroup.on('click', '.BadgeItem', function(){
    var $me = $(this),
        me_img = $me.find('img').attr('src'),
        me_price = $me.attr('data-price'),
        me_id = $me.attr('data-id'),
        me_type = $me.attr('data-type'),
        scale_class = 'none';
    
    if(me_img.includes('scale-up-30')){
      scale_class = 'scale-30';
    } else if (me_img.includes('scale-up-15')){
      scale_class = 'scale-15';
    } else if (me_img.includes('scale-up-10')){
      scale_class = 'scale-10';
    } 

    if($me.hasClass('Selected')){
      hasBadge = false,
      badgeId = null,
      badgeOverlay.classList.add(scale_class);
      badgeOverlay.style.display = 'none';
      badgeOverlay.setAttribute('src', '');
      $me.removeClass('Selected');
      $customizeBtn.addClass('disabled');
      if(me_type == 'Strap'){
        $addAdditional.html(liquidVars.selectStrap);
      } else {
        $addAdditional.html(liquidVars.selectBadge);
      }
    } else {
      hasBadge = true,
      badgeId = me_id,
      $me.addClass('Selected').siblings('.BadgeItem').removeClass('Selected');
      $customizeBtn.removeClass('disabled');
      if(me_type == 'Strap'){
        $addAdditional.html(liquidVars.addStrap + ' - ' + me_price);
        badgeOverlay.classList.remove('scale-30');
        badgeOverlay.classList.remove('scale-15');
        badgeOverlay.classList.remove('scale-10');
        badgeOverlay.classList.add(scale_class);
        badgeOverlay.style.display = 'none';
        badgeOverlayImg.setAttribute('src', '');
      } else {
        $addAdditional.html(liquidVars.addBadge + ' - ' + me_price);
        badgeOverlay.classList.remove('scale-30');
        badgeOverlay.classList.remove('scale-15');
        badgeOverlay.classList.remove('scale-10');        
        badgeOverlay.classList.add(scale_class);
        badgeOverlay.style.display = 'block';
        badgeOverlayImg.setAttribute('src', me_img);
      }
    }
  });

  $badgePreviewBtn.on('click', function(){
    badgePreview();
  });

  $addAdditional.click(function(){
    Utilities.addProductToCart({quantity: 1, id: badgeId});
  });

};

Lemonade.initCartFlyout = function(){

  function getCartJSON(callback, show_flyout){
    $.getJSON('/cart.js', function(cart) {
      if (typeof callback !== undefined) {
        var item_count = "";
        if(cart.item_count > 0){
          item_count = cart.item_count;
        }
				Lemonade.cache.$cartCount.text(item_count);		
        callback(cart, show_flyout);
      }
    })
  }

  function addToCart(e){
    e.preventDefault();
        if ($('#personalization').is(':checked')) {
      if (!$('#personalized-text').val()) {
        $('.missing-text').show()
        return
      }  
            if (!$('#personalization-disclaimer').is(':checked')) {
        $('.personalization-alert').show()
        return
      }      
    }
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
				$addToCartBtnText = $(this).find('span');
		$('.note.errors').remove();
    if($addToCartForm.length) {
			$addToCartBtn
				.attr('data-add-to-cart', $addToCartBtnText.text())
				.prop('disabled', true)
				.addClass('disabled btn--loading');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {
					$addToCartBtn
						.removeClass('btn--loading')
						.prop('disabled', false)
						.removeClass('disabled btn--loading');
          getCartJSON(Utilities.renderCartFlyout, true);
				},
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text(liquidVars.sold_out);
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          $addToCartBtn.closest('.btn-wrap').append('<p class="note errors">' + response + '</p>');
        }
      });
    }
  };

  function updateQuantity(el){
    var $button = $(el),
        $qty = $button.parent().find('.Quantity'),
        oldQty = $qty.val(),
        variant_id = $qty.data('variant');
    
    if ($button.hasClass('up')) {
        var newQty = parseFloat(oldQty) + 1;
      } else {
      if (oldQty > 0) {
        var newQty = parseFloat(oldQty) - 1;
      } else {
        newQty = 0;
      }
    }
    
    Utilities.updateCartQuantity({id: variant_id, quantity: newQty}, function(){
      $qty.attr('value', newQty);
    });
  }

  var $addToCartBtn = $('form[action^="/cart/add"] :submit');

  $addToCartBtn.on('click', addToCart);

  Lemonade.cache.$win.on('resize load', function(e){
    Utilities.resizeCartFlyout();
    if(e.type == 'load'){
      setTimeout(function(){
        Utilities.resizeCartFlyout();
      }, 1500);
    }
  });

  $('#CartTrigger').on('click keyup', function(e){
    e.stopPropagation();
    if(e.type == "click" || e.which == 13 ){
      if(Lemonade.cache.$cartFlyout.hasClass('Show')){
        Utilities.closeCartFlyout();
      } else {
        Utilities.openCartFlyout();
      }
    }
  });

  $('#CartFlyout .close-flyout').add('.main-content').add('#AppBanner').on('click keyup', function(e){
    //e.stopPropagation();
    if(e.type == "click" || e.which == 13 ){
      Utilities.closeCartFlyout();
    }
  });

  Lemonade.cache.$cartFlyout
    .on('click keyup', '.FlyoutQty span', function(e){
      
      if(e.type == "click" || e.which == 13 ){
        $('.FlyoutQty').addClass('processing');
        updateQuantity(this);
      }
    })
    .on('click', '.Remove', function(e){
      if(e.type == "click" || e.which == 13 ){
        Utilities.updateCartQuantity({id: parseFloat($(this).attr('data-variant-id')), quantity: 0});
      }
    });
  
  getCartJSON(Utilities.renderCartFlyout, false);  
  Utilities.resizeCartFlyout();
};

Lemonade.cartNote = function(){
	$('.NoteAdd').click(function(){
		$('.CartNote').toggle();
	});
};


Lemonade.loadMore = function(){

  var $loadMore = $("#LoadMore"),
      loadMoreText = $loadMore.attr('data-button-text'),
      pageNumber = 1;

  // Load more products into the page via AJAX API
  function loadMoreProducts(me, pageNumber, path) {
    
    var wrap = me.closest('.btn-wrap').closest('.GridWrapper').find('.AjaxPager'),
        maxpage = me.data('maxpage'),
        theQuery,
        url;

    if (!path) {
      path = location.pathname;
      theQuery = location.search;

      if (theQuery){
        url = path + theQuery + '&page=' + pageNumber;
      } else {
        url = path + '?page=' + pageNumber;
      }
    }

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      data: theQuery,
      success: function(data) {
        var $data = $(data),
            $new_posts = $data.find(".AjaxPager").html(),
            wrapIndex;
  
        if ($data.length) {
          wrapIndex = pageNumber - 2;
          $(".AjaxPager").append($new_posts);
          Lemonade.lazyLoad();
          me.attr("disabled", false);
          if (maxpage === pageNumber) {
            me.hide();
            $('.LoadMoreWrapper').hide();
          } else {
            me.attr("disabled", false);
          }
        }
      },
      error: function(data) {
        return wrap.append('<div>Something Went Wrong</div>');
      }
    });
  }

	$loadMore.click(function(e) {
		pageNumber++;
		loadMoreProducts($(this), pageNumber);
  });

};

Lemonade.gridToggle = function(){

  var GridBtn = document.querySelectorAll('.GridBtn'),
      CollGrid = document.getElementById('GridToggle'),
      OneCol = document.getElementById('OneCol'),
      TwoCol = document.getElementById('TwoCol');

  function gridToggle(me){
    if(me.getAttribute('id') == 'TwoCol'){
      TwoCol.classList.add('Active');
      OneCol.classList.remove('Active');
      CollGrid.classList.add('TwoCol');
    } else {
      TwoCol.classList.remove('Active');
      OneCol.classList.add('Active');      
      CollGrid.classList.remove('TwoCol');
    }
  }

  GridBtn.forEach(function(element){
    var me = element;
    me.addEventListener('click', function(){
      gridToggle(me);
    });
  });

};

Lemonade.collectionPage = function(){

  var MfsTrigger = document.querySelectorAll('.MobileFSTrigger'),
      Mfw = document.querySelectorAll('.mobile-filter-wrap');

  function mobileFilterSort(me){
    var meFSData = me.getAttribute('data-filters'),
        meFilter = document.getElementById(meFSData);

    if(me.classList.contains('Active')){
      me.classList.remove('Active');
      me.setAttribute('aria-expanded', 'false');
      meFilter.classList.remove('Show');
      meFilter.setAttribute('aria-hidden', 'true');
    } else {
      closeFilters();
      me.classList.add('Active');
      me.setAttribute('aria-expanded', 'true');
      meFilter.classList.add('Show');
      meFilter.setAttribute('aria-hidden', 'false');
    }
  }

  function closeFilters(){
    MfsTrigger.forEach(function(element){
       element.classList.remove('Active');
       element.setAttribute('aria-expanded', 'false');
     });
     Mfw.forEach(function(element){
       element.classList.remove('Show');
       element.setAttribute('aria-hidden', 'true');
     });   
    //document.getElementById('browse-by').style.display = 'none';
    //document.getElementById('browse-by-trigger').classList.remove('Open');
  }
    
  // Mobile Filter/Sort event
  MfsTrigger.forEach(function(element){
    var me = element;
    me.addEventListener('click', function(){
      mobileFilterSort(me)
    });
  });

};

Lemonade.labels = function(){

  var $fieldInputs = $('.field-wrap').find('input').add('select').add('textarea');

  $fieldInputs.on('blur', function(){
    if($(this).val() == '' || $(this).val() == null){
      $(this).closest('.field-wrap').removeClass('float');
    }
  });

  $fieldInputs.on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      var $me = $(this);
      if($me.is(':focus')){
        $me.closest('.field-wrap').addClass('float');
      }
    }
  });

  $fieldInputs.bind("change keyup",function(){
    $(this).closest('.field-wrap').addClass('float');
  });  

  function inputCheck(){
    $fieldInputs.each(function(i,el){
      var $me = $(el);
      if($me.is(':focus') || $me.is(':-webkit-autofill') || $me.val() != ''){
        $me.closest('.field-wrap').addClass('float');
      }
    });
  }

  Lemonade.cache.$win.load(function(){
    inputCheck();
  });
  
};

Lemonade.customizeModule = function(){

  function scatterBadges(container){

    var badges = container.find('.DragImage'),
        degree_h = parseInt(container.attr('data-degree-horizontal')),
        degree_v = parseInt(container.attr('data-degree-vertical')),
        mobile = container.attr('data-mobile'),
        badges_len = badges.length,
        badge_round = Math.round(badges_len / 2),
        $badge = $('.DragImage'),
        i;
    
    if(Lemonade.cache.$body.hasClass('NarrowScreen')){
      if(mobile == 'true'){
        degree_h = degree_h / 2.5;
      }
    }

    function badgePlace(){
      var prev_height = null,
          prev_width = null,
          col_2_prev_height = null,
          col_2_prev_width = null;
        
      for(i=0;i<badges_len;i++){
        
        if(i < badge_round){
          if(Lemonade.cache.$body.hasClass('NarrowScreen') && mobile == 'false'){
            
            // if(prev_width == null){
            //   prev_width = 0;
            // }                    
            // $badge.eq(i).css({
            //   top: 0,
            //   left: prev_width
            // }); 
            // prev_width = prev_width + $badge.eq(i).width();
          } else {
            if(prev_height == null){
              prev_height = 0;
            }        
            if(i % 2 == 0){
              $badge.eq(i).css({
                top: prev_height,
                left: 0
              }); 
            } else {
              $badge.eq(i).css({
                top: prev_height,
                left: degree_h
              }); 
            }
            prev_height = prev_height + $badge.eq(i).height() + degree_v;
          }
        } else {
          if(Lemonade.cache.$body.hasClass('NarrowScreen') && mobile == 'false'){
            // if(col_2_prev_width == null){
            //   col_2_prev_width = 0;
            // }             
            // $badge.eq(i).css({
            //   bottom: 0,
            //   left: col_2_prev_width
            // });          
            // col_2_prev_width = col_2_prev_width + $badge.eq(i).width();
          } else {
            if(col_2_prev_height == null){
              col_2_prev_height = 0;
            } 
            if(i % 2 == 0){
              $badge.eq(i).css({
                top: col_2_prev_height,
                right: degree_h
              });          
            } else {
              $badge.eq(i).css({
                top: col_2_prev_height,
                right: 0
              });          
            }
            col_2_prev_height = col_2_prev_height + $badge.eq(i).height() + degree_v;
          }
        }
        $badge.addClass('Show');
      }

    };

    Lemonade.cache.$win.on({
      load: function(){
        badgePlace();
      },
      resize: function(){
        badgePlace();
      }
    });    

  }

  scatterBadges($('.badge-wrap'));

  $( ".DragImage" ).draggable();

};

Lemonade.resetBadges = function(){
  $('.mobile-1').css({
    top: 0,
    left: '5%',
    right: 'inherit'
  });
  $('.mobile-2').css({
    top: '-20px',
    left: '42%',
    right: 'inherit'
  });
  $('.mobile-3').css({
    top: 0,
    left: '78%',
    right: 'inherit'
  });
  $('.mobile-4').css({
    top: 'initial',
    bottom: 0,
    left: '5%',
    right: 'inherit'
  });
  $('.mobile-5').css({
    top: 'initial',
    bottom: '-20px',
    left: '42%',
    right: 'inherit'
  });
  $('.mobile-6').css({
    top: 'initial',
    bottom: 0,
    left: '78%',
    right: 'inherit'
  });
};

Lemonade.blogPage = function(){
  var $mb = $('#BlogMenu');

  $('.blog-select').click(function(){
    var $me = $(this),
        $me_burger = $me.find('.hamburger');
    if($me_burger.hasClass('Open')){
      $me.attr('aria-expaned', 'false');
      $me_burger.removeClass('Open');
      $mb.hide().attr('aria-hidden', 'true');
    } else {
      $me.attr('aria-expaned', 'true');
      $me_burger.addClass('Open');
      $mb.show().attr('aria-hidden', 'false');
    }
  });

};


Lemonade.partialSearch = function(){
  var $header_search = $('.search-form');

  $header_search.find('input[type="search"]').val('');
  
  $header_search.on('submit', function(){
    var me_val = $(this).find('input[type="search"]').val(),
        new_val = me_val + '*';

    $(this).find('input[type="search"]').val(new_val); 
    
  });
};

// Initialize Lemonade JS on docready
$(Lemonade.init);